import { useState } from 'react'
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt, FaFacebookF, FaInstagram, FaLinkedinIn } from "react-icons/fa";

function Contact() {
    const [contactForm, setContactForm] = useState({
        name: "",
        email: "",
        msg: ""
    })

    const handleContact = (e) => {
        e.preventDefault();
        if (contactForm?.name && contactForm?.email && contactForm?.msg) {
            alert("Thank you for contacting us. We will get back to you shortly.");
            setContactForm({
                name: "",
                email: "",
                msg: ""
            })
        } else {
            alert("All Fields are Mandatory");
        }
    }

    return (
        <div >

            <div className="position-relative "
                style={{ marginTop: "370px" }}>

                <div
                    className="position-relative w-100 overflow-hidden"
                    style={{ height: "320px" }}
                    data-aos="fade-up"
                >
                    <svg
                        viewBox="0 0 1440 320"
                        preserveAspectRatio="none"
                        className="position-absolute bottom-0 start-0 w-100 h-100"
                    >
                        <path
                            d="
                             M0,160
                             Q720,-120 1440,160
                             L1440,320
                             L0,320
                             Z"
                            className=""
                            style={{ fill: "rgba(9, 26, 58, 1)" }}
                        />
                    </svg>
                </div>



                <section className="contact-section1d py-5 position-relative "
                    style={{
                        marginTop: "-650px",  // pulls section upward
                        zIndex: 10,           // above curve
                    }}
                >
                    <div className="container">

                        <div className="row justify-content-center">
                            <div className="col-lg-10 col-xl-9">

                                {/* Heading */}
                                <div className="text-center mb-5" data-aos="fade-up">
                                    <h2 className="fw-bold">Contact Us</h2>
                                    <p className="text-muted">
                                        Get in touch with us for reliable warehousing & logistics solutions
                                    </p>
                                </div>

                                <div className="row align-items-stretch">
                                    {/* Contact Info */}
                                    <div
                                        className="col-md-5 mb-4 mb-md-0"
                                        data-aos="fade-right"
                                    >
                                        <div className="contact-info1 h-100">
                                            <h4 className="mb-4">Reach Us</h4>

                                            <div className="info-item">
                                                <FaMapMarkerAlt />
                                                <p>
                                                    Tamil Nadu Warehousing Corporation,
                                                    82 Anna Salai, Guindy, Chennai - 600032,
                                                    Tamil Nadu, India.
                                                </p>
                                            </div>

                                            <div className="info-item1">
                                                <FaPhoneAlt />
                                                <p>044 2235 1497, 044-22302300, 044-22351798 </p>
                                            </div>



                                            <div className="info-item">
                                                <FaEnvelope />
                                                <p>info@tnwc.com</p>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Contact Form */}
                                    <div
                                        className="col-md-7"
                                        data-aos="fade-left"
                                    >
                                        <div className="contact-form">
                                            <form onSubmit={handleContact}>
                                                <div className="form-floating mb-3">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Your Name"
                                                        value={contactForm?.name}
                                                        onChange={(e) => setContactForm((pv) => ({ ...pv, name: e.target.value }))}
                                                    />
                                                    <label htmlFor="name">Your Name</label>
                                                </div>

                                                <div className="form-floating mb-3">
                                                    <input
                                                        type="email"
                                                        className="form-control"
                                                        placeholder="Your Email"
                                                        value={contactForm?.email}
                                                        onChange={(e) => setContactForm((pv) => ({ ...pv, email: e.target.value }))}
                                                    />
                                                    <label htmlFor="email">Your Email</label>
                                                </div>

                                                <div className="form-floating mb-3">
                                                    <textarea
                                                        className="form-control"
                                                        placeholder="Your Message"
                                                        style={{ height: "130px" }}
                                                        value={contactForm?.msg}
                                                        onChange={(e) => setContactForm((pv) => ({ ...pv, msg: e.target.value }))}
                                                    ></textarea>
                                                    <label htmlFor="message">Your Message</label>
                                                </div>

                                                <div className="d-flex justify-content-center">
                                                    <button
                                                        type="submit"
                                                        className="btn contact-btn"
                                                        style={{ backgroundColor: "rgba(9, 26, 58, 1)", color: "white" }}
                                                        data-aos="zoom-in"
                                                        data-aos-delay="200"
                                                    >
                                                        Send Message
                                                    </button>
                                                </div>

                                            </form>
                                        </div>
                                    </div>
                                </div>


                            </div>
                        </div>
                    </div>
                </section >


            </div>
        </div>
    );
}

export default Contact